import React from 'react';

/** Two pets linked by a spark: quick peer-to-peer sync, no plugins. */
export default function PeerSyncIcon({ size = 24, color = 'currentColor', className = '' }) {
  const head = (x) => (
    <g>
      <rect x={x} y="12" width="7" height="6.5" rx="2" fill={color} opacity="0.15" />
      <rect x={x} y="12" width="7" height="6.5" rx="2" stroke={color} strokeWidth="1.5" />
      <path d={`M${x + 1} 12l.6-1.8 1.3 1.8M${x + 6} 12l-.6-1.8-1.3 1.8`} stroke={color} strokeWidth="1.3" strokeLinejoin="round" />
      <circle cx={x + 2.4} cy="15.1" r="0.8" fill={color} />
      <circle cx={x + 4.6} cy="15.1" r="0.8" fill={color} />
    </g>
  );
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      {head(1.5)}
      {head(15.5)}
      {/* The spark between them */}
      <path d="M12.8 4.5 10.2 9.8h2.6l-1.6 4.7 3.6-6.2h-2.7l1.7-3.8Z" fill={color} stroke={color} strokeWidth="0.8"
            strokeLinejoin="round" />
      <path d="M8.5 15.2h1.3M14.2 15.2h1.3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeDasharray="0.1 2.4" />
    </svg>
  );
}
